import React, { useState, Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import { Typography, CircularProgress, Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Backdrop } from '@material-ui/core';
import { useForm,Controller } from 'react-hook-form';
import { useAuth0 } from '../hooks/react-auth0-spa';
import Axios from 'axios';
import { API_URL } from '../constants/constants';
import MaterialTable from 'material-table';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import MoneyOffIcon from '@material-ui/icons/MoneyOff';
import red from '@material-ui/core/colors/red';
import green from '@material-ui/core/colors/green';
import { useSnackbar } from 'notistack';


const useStyles = makeStyles((theme) => ({
    root: {
      padding: '2px 4px',
      display: 'flex',
      alignItems: 'center',
      width:'100%',
      margin:20
    },
    input: {
      marginLeft: theme.spacing(1),
      flex: 1,
    },
    iconButton: {
      padding: 10,
    },
    divider: {
      height: 28,
      margin: 4,
    },
    dialog:{
      width:500,
      height:'50%',
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}))
const Admin = () => {
  const { enqueueSnackbar } = useSnackbar();
    const methods=useForm();
    const { handleSubmit, control } = methods;
    const {handleSubmit:handleSubmit2,control:control2}=useForm();
    const [open, setOpen] = useState(false);
    const [openRed, setOpenRed] = useState(false);
 
    const handleClickOpenRed = () => {
      setOpenRed(true);
    };
  
    const handleCloseRed = () => {
      setOpenRed(false);
    };
    const handleClickOpen = () => {
      setOpen(true);
    };
  
    const handleClose = () => {
      setOpen(false);
    };
    const [buscar,setBuscar]=useState(false);
    const [data,setData]=useState();
    const [loading,setLoading]=useState(false);
    const { getTokenSilently } = useAuth0();
    const classes = useStyles();
    const[cargando,setCargando]=useState(false)
    const buscarUsuario=async({email})=>{
        // console.log(email);
            setBuscar(false);
            setLoading(true);
            try {
              const t = await getTokenSilently();
              const r = await Axios.get(API_URL + `/email_user/${email}`, {
                headers: {
                  Authorization: `Bearer ${t}`
                }
              });
              // console.log(r.data);
            //   console.log(r.data)
              setData(r.data);
            } catch (error) {
              // console.log(error);
              // setIsError(true);
            }
            setBuscar(true);
            setLoading(false);

          
    }

    const onSubmit=async (info)=>{
      try {
        setCargando(true)
        // console.log(info)
        const t = await getTokenSilently();
        await Axios.patch(API_URL + `/email_user/${data[0].user_id}`,{
          descripcion:info.descripcion,
          amount:info.amount,
          gasto:openRed
        } ,{
          headers: {
            Authorization: `Bearer ${t}`
          }
        });
        let a='success'
        enqueueSnackbar('Usuario Actualizado',{a})
      
      } catch (error) {
        let b='error'
        enqueueSnackbar('No se pudo actualizar',{b})
      }finally{
        setOpenRed(false)
        setOpen(false)
        setCargando(false)
      }
  
    }
    // console.log(data)
  return (
      <div style={{margin:20}}>
      
        <Typography variant="h4" component="h2" style={{marginBottom:"20px"}}>
             Buscar Usuario
        </Typography>
        <form onSubmit={handleSubmit(buscarUsuario)}>
        <Paper component="form" className={classes.root}>
          
            <Controller 
            name="email"
            control={control}
            as={<InputBase
                className={classes.input}
                placeholder="Email del Usuario"
            />} />
            {loading?<CircularProgress/>
            :<IconButton  className={classes.iconButton} aria-label="search" type="submit" >
                <SearchIcon />
            </IconButton>}

        
        </Paper>
          </form>
        {buscar&&(
            <Fragment>
            <MaterialTable
                title="Usuario"
                columns={[
                    {title:"Nombre",field:'nombre'},
                    {title:"Telefono",field:'telefono'},
                    {title:"Email",field:"email"},
                    {title:"Saldo",field:"saldo"}
                ]}
                options={{
                    toolbar:false,
                    search:false,
                    sorting:false,
                    pageSize:1,
                    paging:false,


                }}
                data={data}
                actions={[
                    rowData=>({
                        icon:()=><MoneyOffIcon style={{color:red[500]}} />,
                        tooltip:"Descontar Dinero",
                        onClick: handleClickOpenRed

                    }),
                    rowData=>({
                        icon:()=><AttachMoneyIcon style={{color:green[500]}} />,
                        tooltip:"Añadir Dinero",
                        onClick: handleClickOpen
                    }),
                ]}
            
            />
            <div >
               <Dialog
               open={open}
               onClose={handleClose}
               aria-labelledby="alert-dialog-title"
               aria-describedby="alert-dialog-description"
              
             >
               <Backdrop  open={cargando}  className={classes.backdrop}>
                <CircularProgress color="inherit" />
              </Backdrop>
               
               <DialogTitle id="alert-dialog-title">{"Añadir Saldo"}</DialogTitle>
               <form onSubmit={handleSubmit2(onSubmit)}>
               <DialogContent>  
                 <Controller
                 rules={{required:true}}
                  as={ <TextField required id="standard-required" label="Descripción" placeholder="Descripcion del cargo" />}
                  control={control2}
                  name="descripcion"
                 />
                </DialogContent>
               <DialogContent style={{marginTop:30}} >
                 <Controller
                    as={<TextField
                    required
                      id="standard-number"
                      label="Cantidad"
                      type="number"
                      
                    />}
                  name="amount"
                  rules={{required:true}}
                  control={control2}
                 />
               
               </DialogContent>
               <DialogActions>
                 <Button onClick={handleClose} color="primary">
                  Cancelar
                 </Button>
                 <Button type='submit' color="primary" autoFocus>
                   Confirmar
                 </Button>
               </DialogActions>
                   
                 </form>
             </Dialog>

            </div>
            <div className={classes.dialog}>

               <Dialog
               open={openRed}
               onClose={handleCloseRed}
               aria-labelledby="alert-dialog-title"
               aria-describedby="alert-dialog-description"
             >
                      <Backdrop  open={cargando}  className={classes.backdrop}>
                <CircularProgress color="inherit" />
              </Backdrop>
               <DialogTitle id="alert-dialog-title">{"Quitar Saldo"}</DialogTitle>
               <form onSubmit={handleSubmit2(onSubmit)}>
               <DialogContent>  
                 <Controller
                  as={ <TextField required id="standard-required" label="Descripción" placeholder="Descripcion del cargo" />}
                  control={control2}
                  name="descripcion"
                  rules={{required:true}}
                 />
                </DialogContent>
               <DialogContent style={{marginTop:30}} >
                 <Controller
                    as={<TextField
                      id="standard-number"
                      label="Cantidad"
                      type="number"
                      required
                      
                    />}
                  name="amount"
                  rules={{required:true}}
                  control={control2}
                 />
               
               </DialogContent>
               <DialogActions>
                 <Button onClick={handleCloseRed} color="primary">
                  Cancelar
                 </Button>
                 <Button type='submit' color="primary" autoFocus>
                   Confirmar
                 </Button>
               </DialogActions>
                   
                 </form>
             </Dialog>
     

            </div>

      
            </Fragment>

        )}
        

      </div>
  );
}
 
export default Admin;